<!-- Button -->
<div class="flex flex-row items-center">
  <button mat-icon-button [matMenuTriggerFor]="sites">
    <mat-icon [ngClass]="{'text-red-500': user.site.name === ''}" [svgIcon]="'iconsmind:hotel'">
    </mat-icon>
  </button>
  <div>{{user.site.name}}</div>
</div>

@if (flashMessage) {
  <div class="flex items-center mr-4 bg-red-100">
    @if (flashMessage === 'error') {
      <mat-icon class="text-red-500" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
      <span class="ml-2">{{ flashError }}</span>
    }
  </div>
}

<!-- Site menu -->
<mat-menu [xPosition]="'before'" #sites="matMenu" class="max-h-120">
  @for (site of availableSites; track trackByFn($index, site)) {
    <button mat-menu-item (click)="updateUserSite(site.id)">
      <span class="flex items-center">
        <span class="ml-3">{{site.name}}</span>
        <span class="text-primary-400 ml-3">({{site.id}})</span>
      </span>
    </button>
  }
</mat-menu>